import {map} from "underscore";

export const RESTART_REQUIRED_MESSAGE =
  "This task can't continue. " +
  "Check what's already done, then send a new request.";

export const FINISHED_TASK_MESSAGE =
  "This task has already finished. No additional operations were run.";

export const CANCELLED_TASK_MESSAGE =
  "This task was already cancelled. No additional operations were run.";

export const SUPERSEDED_TASK_MESSAGE =
  "A newer request replaced this task, so this older task stopped. " +
  "Continue with the newer request.";

export const SCHEMA_CHANGED_MESSAGE =
  "Your organization's available options have changed. " +
  "The changes in this approval weren't run. Send a new request to review them again.";

export const SCHEMA_UNAVAILABLE_MESSAGE =
  "I couldn't check your organization's available options. " +
  "I stopped this step before making changes. Please send a new request later.";

const getRestartReason = (value) => value?.restartReason || value?.details?.restartReason;

export const getRestartRequiredMessage = (value) => {
  const restartReason = getRestartReason(value);
  if (restartReason === "agent_state_complete") {
    return FINISHED_TASK_MESSAGE;
  }
  if (restartReason === "agent_state_cancelled") {
    return CANCELLED_TASK_MESSAGE;
  }
  if (restartReason === "run_superseded") {
    return SUPERSEDED_TASK_MESSAGE;
  }
  if (restartReason === "schema_changed") {
    return SCHEMA_CHANGED_MESSAGE;
  }
  if (restartReason === "schema_unavailable") {
    return SCHEMA_UNAVAILABLE_MESSAGE;
  }
  return RESTART_REQUIRED_MESSAGE;
};

export const isRestartRequired = (value) =>
  value?.restartRequired === true ||
  value?.error === "restart_required" ||
  value?.code === "restart_required" ||
  value?.details?.restartRequired === true;

export const buildConfirmationDecisions = (items, approved, itemDecisions) => {
  if (approved && itemDecisions) {
    return itemDecisions;
  }

  return map(items, (item) => ({
    index: item.index,
    approved,
  }));
};
